import { useState, useEffect } from 'react';
import useTokenEpayco from './useTokenEpayco';
import config from '../../utils/apiUrl';

export const useFinancialInstitutions = () => {
  const { getTokenApify } = useTokenEpayco();
  const [institutions, setInstitutions] = useState([]);
  const [error, setError] = useState(null);

  const getFinancialInstitutions = async () => {
    try {
      const tokenApify = await getTokenApify();
      const response = await fetch(
        `${config.epayco.apiUrl}/payment/pse/banks`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${tokenApify}`,
          },
        }
      );

      const data = await response.json();
      if (response.ok && data.data) {
        setInstitutions(data.data);
      } else {
        throw new Error('No se pudieron obtener las instituciones financieras');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    getFinancialInstitutions();
  }, []);

  return { institutions, error };
};
